//private
export async function _ensureNativeModuleIsInitialized(nativeModule, clientId, domain) {
  const hasValid = await nativeModule.hasValidAuth0Instance();
  if (!hasValid) {
    await nativeModule.initializeAuth0(clientId, domain);
  }
}
//# sourceMappingURL=nativeHelper.js.map